enum DispatcherAddViewMode {
  CARGO = "CARGO",
  RAILY = "RAILY",
}

export default DispatcherAddViewMode;
